"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var t = require("io-ts");
var rpc = require("../rpc");
var UploadUrlResponseValidator = t.type({
    uploadUrl: t.string,
    uploadToken: t.string,
    publicUrl: t.string,
});
exports.MediaService = rpc.service({
    getUploadUrl: rpc.method(t.string, UploadUrlResponseValidator),
});
